<section class="row-freight d-flex px-0 px-sm-2">
    <div class="col-12 px-0 d-flex flex-wrap position-relative">
        <div class="col-lg-4">
            <div class="label">Nombre</div>
            <div class="text-bold label-field" title="{{thirdParty?.name}}">
                {{thirdParty?.name ? thirdParty?.name : '-'}}
            </div>
        </div>
        <div class="col-lg-4 col-md-6">
            <div class="label">
                Tipo de documento
            </div>
            <div class="text-bold label-field" title="{{getDocumentType()}}">
                {{getDocumentType()}}
            </div>
        </div>
        <div class="col-lg-4 col-md-6">
            <div class="label">
                Documento
            </div>
            <div class="text-bold label-field" title="{{thirdParty?.document}}">
                {{thirdParty?.document ? thirdParty?.document : '-'}}
            </div>
        </div>
        <app-rndc-contingency-alert class="col-12 mt-5" [entity]="thirdParty"
            entityType="thirdParty"></app-rndc-contingency-alert>

    </div>
    <i class="fas fa-eye icon-detail-third-party" (click)="goToDetail()" *ngIf="thirdParty?.document"></i>
</section>